/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from 'react';

export default function useClickOutside(
    ref: { [index: string]: any },
    state: { [index: string]: any },
    callback: (state?: any, event?: Event) => void,
    buttonRef?: { current: any },
) {
    useEffect(() => {
        function handleClickOutside(event: Event) {
            if (
                ref.current &&
                !ref.current.contains(event.target) &&
                (!buttonRef?.current || !buttonRef.current.contains(event.target))
            ) {
                callback(state, event);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('touchend', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchend', handleClickOutside);
        };
    }, [ref, state, callback, buttonRef]);
}
